import axios from 'axios'

const fetchFlows = async (referenceId, flowDefinitionId) => {
  if (!referenceId) return []

  const { data } = await axios.get(
    `/api/flow/flows?flowDefinitionId=${flowDefinitionId}&data.referenceId=${referenceId}&status=!archived&sort=createdAt&dir=-1&stripTaskPatches=true&limit=2`
  )
  return data
}

export default {
  fetchFlows
}
